import { SpecialModalController } from './special-modal.component';

export class SpecialModalService {

  constructor($timeout, $modal, $http, ErrorHandlerService, PermissionService) {
    this.$timeout = $timeout;
    this.$modal = $modal;
    this.$http = $http;
    this.ErrorHandlerService = ErrorHandlerService;
    this.PermissionService = PermissionService;
  }

  open( permission, confirmation, onSuccess) {
    return this.$modal.open({
      template  : require('./special-modal.component.html'),
      controller: SpecialModalController,
      resolve   : {
        'success': () => onSuccess,
        'permission': () => permission,
        'confirmation': () => confirmation,
      },
    });
  }

  deleteEvent(eventId, onSuccess) {
    let self = this;
    this.open("can_delete_event", gettext("Удалить это событие и все связанные с ним файлы?"), function ok(token) {
        self.$http.get("/admin/delete-event/?token=" + token + "&id=" + eventId).then(
            function success() {
                onSuccess();
            },
            function failed(error) {
                self.ErrorHandlerService.handle(error);
            }
        )
    });
  }

  deleteSpecial(permission, confirmation, onSuccess) {
    let self = this;
    // Called from plain JS, so load permissions first
    this.PermissionService.load( function loaded() {
        self.open(permission, confirmation, function ok(token) {
            onSuccess(token);
        })
    })
  }

  openTerminal() {
    this.open("can_access_terminal", false, function ok(token) {
        window.open("/console/console/?token=" + token);
    });
  }
}



// WEBPACK FOOTER //
// ./src/core/special-modal/special-modal.service.js